import { ProductCardActionsView } from "./ProductCardActions.componentView";
import { ProductCardActionsProps } from "./ProductCardActions.componentModel";
import { useComponentModel } from "./ProductCardActions.componentService";

export function ProductCardActions(props: ProductCardActionsProps) {
  const { componentData, componentService } = useComponentModel({ ...props });

  if (!componentData.buttonStack?.length) return null;

  const onAddToCart = () => {
    componentService.onAddToCart(componentData.itemCount);
  };

  //CUSTOM BUSINESS LOGIC HERE
  return (
    <ProductCardActionsView
      componentData={componentData}
      setQuantity={componentService.setQuantity}
      onAddToCart={onAddToCart}
    />
  );
}
